export default __webpack_public_path__ + "locales/es/InviteDialog.json?hash=ff2b107f33122352b9b21009d6f13a82";